import * as React from 'react';

import FilePages16 from './FilePages16';

export const filePages16 = () => <FilePages16 />;

export default {
    title: 'Icon|Fill|FilePages16',
    component: FilePages16,
    parameters: {
        notes: "`import FilePages16 from 'box-ui-elements/es/icon/fill/FilePages16';`",
    },
};
